<div class="lum-c-fulfillment-order-autocomplete-control">
  <lum-ui-autocomplete
    [control]="control"
    [placeholder]="displayValue || 'Search Fulfillment Order ID'"
    [options]="records"
    [debounceTime]="500"
    [loading$]="loadingRecords$"
    [displayProperty]="'id'"
    [value]="displayValue"
    [displayNoResults]="true"
    [disabled]="disabled"
    (inputChangeEvent)="onInputChange($event)"
    (optionSelectedEvent)="onSelectItem($event)"
    (inputFocusedEvent)="getRecords()"
    (scrollPaginate)="getRecords()"
  ></lum-ui-autocomplete>
</div>
